(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2038],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js
'use client';



const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paper_Paper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/getOverlayAlpha.js
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
/* harmony default export */ var styles_getOverlayAlpha = (getOverlayAlpha);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/paperClasses.js


function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/Paper.js
'use client';



const _excluded = ["className", "component", "elevation", "square", "variant"];













const useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};
const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (false) {}
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);

/***/ }),

/***/ 82056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useRtl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["value"];



const RtlContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();
function RtlProvider(_ref) {
  let {
      value
    } = _ref,
    props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RtlContext.Provider, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    value: value != null ? value : true
  }, props));
}
 false ? 0 : void 0;
const useRtl = () => {
  const value = react__WEBPACK_IMPORTED_MODULE_0__.useContext(RtlContext);
  return value != null ? value : false;
};
/* harmony default export */ __webpack_exports__["Z"] = (RtlProvider);

/***/ }),

/***/ 250:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications",
      function () {
        return __webpack_require__(96571);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84538:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/11.86026da2.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42hXKvUrDUBiH8f97zkmkxhowIDi6qYOL4uzQrYsiuHsJ3oIX4OwmuDm5GDq6OHgDFR1rIygFrW1jkvPxvm2f9ffQ6f3oQhN1Y4XSM5QVgQAcESUskhti7tYsZ4UXZIbQUgABqBmIFEH1p1V5mDIudyI7rutw3UnD7UlmD9KA91lVGuusshY4P9rSnd223mjHEBEUfw3WOSi1px16xRRvwwmWuKz/McHj9wyb5KD+m4YzeHz9VsF5Dq+DcbjqDcI2eVQLM87ZBES4e/mMb56HePhx2F9Rek3TYpDEgDlvBHgaubJFUMerGo6ZrUdChHwOGAl8LfDGLzAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 79711:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/15.e11c799e.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42mMQXfVXZNVfydV/OVf9ZVjwh2HhH+nVIBEGgUW/RBb/Yl30S33Jr9Xnfy8584dhwS+Jxb8YuGZ8VZv1laHry46LP////7vr4k+GqV/FZ35l4O35KNv3kaHtw+2nv64//sVQ+0G5/yNXz0cG+eY3DMWvTl///v//PyA6d/M7Q8lrOaAgZ9lzhtLnrk0v7j/98fDZD+v6Fwwlz7mBggxZj1UKnjA4PLh06+vVO18ZnB4AuUBBBobkB/LpDxlc7l29/fXG3a8MrvfkgNzkBwAlaHR/cn2xQAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 69489:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/16.b0f4cb05.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42mOAgfvRAbF3woPW3wkJWH8/2juWARnc9HebecfX8f9DZ4H/D5yY/t+ysPh/Xcd5JkR2eVbsumSn/4+SQv+cX334z7n1h/68nBf4580c4/9fNrrEMDCszlsfN8Hx/4llB/+4z/3/X3fiv/8PLh768/8i4/+/Z3zWM6gtyljPsND7/4K9x/7kTvr337Xn7/+75w7/+X+e+/+fs0AFGguTYhjmR/8PXJX7Z8a+Y3/m7Tr65+f5iD//z1r+/3PGLQbsDMX5cTMF5oX/Z5ju9H//JrX//89b/P99GuJIBJgXHxMwO3b9txM+6/+fc42BCQMALP+AFtMto2sAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 57614:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/17.5c307e48.svg","height":44,"width":44});

/***/ }),

/***/ 49967:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/18.74eca1d7.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5klEQVR42lWPO2sCQRSFJ2XqFGmENIEkViH/LKQKIUiKEIL/QRufpZbrzAjjG5TVRt1xBV18oOiAIMIyxXFmC8ELt7nnnnPvR2wBeFFSCi+b07aVnAg7u4hzShWLPaP3nUAv8QP+EMecMhUtWSd/esWy2QpnjoNFrY6N64Y8/gabRMaZrHZ//7BsNBDwKtj9I7aDAfr/SXhGIzJf0J33D5uAQxCA3cawG47Q/fyCZzSiJr6ghFhHeFyvsWp3TBIPKbmD8n0RPTktldUwlYYhACU30ZmAcXVFctrvxcypaFkoauO8YJ4BYV21J40VIu8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 4201:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/19.a0fb6d13.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA3ElEQVR42kWPPUsDQRiE7yf5j+ys7JQt/Q2ChaTRKmKbC4nRSpAVFCURREQLCxNC7iu3e/vuXjb3ZvJxJBmYZp4pZoKttLVCM8uNy1LU6R6GKo6Q3d8h6XYxHY6QF0VYQ7JiDaPjI59eNdjcXLL7fPWFI0zTTAS5W0j73YZ/POdkBvQGJTovxH//CmSUDPSqoH7a+B1cMBHw/Fbi4Iz4qa8wn+UyIGNFnMU4bJ34hrzm2/cmnza/fBQbGJPVY6mgcJJG6Hw8oNXvYZwMQfXIvUgbUbm5rFwlSbvdzSWzoLMLtNFDUQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 59535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/19.5679bc9c.webp","height":500,"width":500,"blurDataURL":"data:image/webp;base64,UklGRrgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDUAAAABYFTbtpL7fyJcE8EMIvjoJxYOFiIiwipZllRWA8CoFLyHbMWDZ9//ZwneQ60JYJZR51wvAwBWUDggXAAAABACAJ0BKggACAACQDglqAJ0bX8Cf/ZavwAA/uF7p+CX9JNUfAujS/l7nzfxrUS6AJ+/N8rDpz09Xa6EmSKsOH87DcKQIfs9z/+qEaDn6QY+1IVdsn6sw23bG5gA","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 88101:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/21.fbc5244f.webp","height":256,"width":256,"blurDataURL":"data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAAAwAgCdASoIAAgAAkA4JbACdG1/AvJ6mk/kgAD+9V8xK7aNYidyuvn2g0ZxDfaWrvhjbNtsMcz9wVv2LPD535g3rjPftuXRF31f2Gv1gPnwBy+s6/Jv5y/5UQAAAA==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 95598:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/22.88cba043.webp","height":190,"width":190,"blurDataURL":"data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACwAQCdASoIAAgAAkA4JaQAAud7cY6AAP7903IdG/csJky5UrmwLHI9itWZzYdZAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 47234:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/7.c1a6ff67.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAzElEQVR42mN4oKXKyIADwOWeG2iJPVVXMHtub23x3Nvd4qmGotlzfU0xsOQtDWWOBxrKNx4a6Py/z8AAxg/1tf8/0FS5cUtNiYPhiqqy/HVdnS9XgRJvjxz582D+/D8g9nUdrS9X1FTkGY7JKcidUdP4foqB4f/jTZv+3+jr+w9in1FV+w6SY1guKs56QFTq5EFF1f/7GBj+gPBBBZX/B8SkT64QFmVlAIFOCRmulQxMyht8/FTXe3iprmRgU+4RleICS+4Rl8HmTbgcAIKzT0pjg1p+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 47206:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/8.59b9a5ea.jpg","height":180,"width":180,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAAkQn/AP/EAB4QAAEEAQUAAAAAAAAAAAAAAAIBAwQSEQAFBmKi/9oACAEBAAE/ABDZYvHnHLtSJckGsIpJdg0UrYHr61//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/AFtP/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQARcf/aAAgBAwEBPwBArJ//2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 96571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ applications; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/images/apps/7.png
var _7 = __webpack_require__(47234);
// EXTERNAL MODULE: ./public/images/apps/8.jpg
var _8 = __webpack_require__(47206);
// EXTERNAL MODULE: ./public/images/apps/11.png
var _11 = __webpack_require__(84538);
// EXTERNAL MODULE: ./public/images/apps/17.svg
var _17 = __webpack_require__(57614);
// EXTERNAL MODULE: ./public/images/apps/18.png
var _18 = __webpack_require__(49967);
// EXTERNAL MODULE: ./public/images/apps/19.png
var _19 = __webpack_require__(4201);
;// CONCATENATED MODULE: ./public/images/apps/3.png
/* harmony default export */ var _3 = ({"src":"/_next/static/media/3.d1683495.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AQEAjgBNLTR+Hi0GZRsVAQQN+/wAA9j2/AC+9psKANOCAWoArnE2gheOMTwTAP3r8AAEAAAACRkQAOa75wDrg+VyAY8fn8lHmzE27KfI/BNBJQMEBQIABAP+/QYPEgTdSc7KAbVHkMwnYiszBf/9/gTz8wIA/wIA/gwM/gECBQLsl9jNAddaaMwXWUozAunh/v8TIAL//wIA+eHs/gIdHALtkM3NAepmAMINXLY9AdXM+gAQFAT7+QMA+un3/AAsNAbpS6zDAep8AFIOMWitBCtOAP/z9gD+9v8A/voGAO2nywDqnupTAf+fAADpDzlKCgoEYwECFAf+5ekB9rfG+OyqH50YABq2gH9uogOIZAIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/apps/5.png
/* harmony default export */ var _5 = ({"src":"/_next/static/media/5.e11c799e.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42mMQXfVXZNVfydV/OVf9ZVjwh2HhH+nVIBEGgUW/RBb/Yl30S33Jr9Xnfy8584dhwS+Jxb8YuGZ8VZv1laHry46LP////7vr4k+GqV/FZ35l4O35KNv3kaHtw+2nv64//sVQ+0G5/yNXz0cG+eY3DMWvTl///v//PyA6d/M7Q8lrOaAgZ9lzhtLnrk0v7j/98fDZD+v6Fwwlz7mBggxZj1UKnjA4PLh06+vVO18ZnB4AuUBBBobkB/LpDxlc7l29/fXG3a8MrvfkgNzkBwAlaHR/cn2xQAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/apps/6.png
/* harmony default export */ var _6 = ({"src":"/_next/static/media/6.15df0ba0.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA70lEQVR42h3PoU7DQByA8e9/vbZrU0iqyAgIkplhCaLJBApDcEgsCRKDWoKGN9g8CRrJAyz1CB6ABZaAGANKu7srR9inP/MTgPb4bJfEjUjrgqyBrC0JqnPgSarDi74O7USHy1yyFq8/kfQDn8dzZDlQFj12Tue/C288KQyv8d19I4sqR+KRslFSuMcKf3kacTOEXg+OTiJe3qDtFMpKiJkJ7GyjNrusilN8tQaNRrWO0u3l1LcPxk1nMH2Fu3sj6RZ8B6U8H1z1VRxM9PtX3rE1UdAQrreoDT0nqAYC8D/pRI1DbBGLIdKm1PZnxfwD/ppZ+cf10hIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/apps/12.svg
/* harmony default export */ var _12 = ({"src":"/_next/static/media/12.fd8906cc.svg","height":48,"width":47});
;// CONCATENATED MODULE: ./public/images/apps/13.svg
/* harmony default export */ var _13 = ({"src":"/_next/static/media/13.8bff0ce2.svg","height":25,"width":48});
;// CONCATENATED MODULE: ./public/images/apps/14.svg
/* harmony default export */ var _14 = ({"src":"/_next/static/media/14.40625296.svg","height":44,"width":44});
// EXTERNAL MODULE: ./public/images/apps/15.png
var _15 = __webpack_require__(79711);
// EXTERNAL MODULE: ./public/images/apps/16.png
var _16 = __webpack_require__(69489);
// EXTERNAL MODULE: ./public/images/apps/19.webp
var apps_19 = __webpack_require__(59535);
;// CONCATENATED MODULE: ./public/images/apps/20.webp
/* harmony default export */ var _20 = ({"src":"/_next/static/media/20.51508104.webp","height":240,"width":420,"blurDataURL":"data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAAAQAgCdASoIAAUAAkA4JYwCw+BAAakhHQaAAP772HUD5V5Im/uh2OWQ9Y60/8B9txC5xi4cR/wbXggrU7t9qoVcAAA=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./public/images/apps/21.webp
var _21 = __webpack_require__(88101);
// EXTERNAL MODULE: ./public/images/apps/22.webp
var _22 = __webpack_require__(95598);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/RtlProvider/index.js
var RtlProvider = __webpack_require__(82056);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/LinearProgress/linearProgressClasses.js


function getLinearProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiLinearProgress', slot);
}
const linearProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);
/* harmony default export */ var LinearProgress_linearProgressClasses = (linearProgressClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js
'use client';



const _excluded = ["className", "color", "value", "valueBuffer", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;













const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t3 || (_t3 = _`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,capitalize/* default */.Z)(color)}`, variant],
    dashed: ['dashed', `dashedColor${(0,capitalize/* default */.Z)(color)}`],
    bar1: ['bar', `barColor${(0,capitalize/* default */.Z)(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${(0,capitalize/* default */.Z)(color)}`, variant === 'buffer' && `color${(0,capitalize/* default */.Z)(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }
  if (theme.vars) {
    return theme.vars.palette.LinearProgress[`${color}Bg`];
  }
  return theme.palette.mode === 'light' ? (0,colorManipulator/* lighten */.$n)(theme.palette[color].main, 0.62) : (0,colorManipulator/* darken */._j)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return (0,esm_extends/* default */.Z)({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${(0,capitalize/* default */.Z)(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0,emotion_react_browser_esm/* css */.iv)(_t5 || (_t5 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = (0,styled/* default */.ZP)('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${(0,capitalize/* default */.Z)(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0,emotion_react_browser_esm/* css */.iv)(_t6 || (_t6 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const LinearProgress = /*#__PURE__*/react.forwardRef(function LinearProgress(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiLinearProgress'
  });
  const {
      className,
      color = 'primary',
      value,
      valueBuffer,
      variant = 'indeterminate'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const isRtl = (0,RtlProvider/* useRtl */.V)();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    } else if (false) {}
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    } else if (false) {}
  }
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LinearProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/(0,jsx_runtime.jsx)(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var LinearProgress_LinearProgress = (LinearProgress);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
;// CONCATENATED MODULE: ./src/pages/applications/index.js
/* eslint-disable jsx-a11y/alt-text */ 
























function Index() {
    const APPLICATIONS = [
        {
            id: 1,
            title: "Youtube",
            img: _7/* default */.Z,
            time: "29 Oct, 05:47 pm",
            size: "14.94 MB"
        },
        {
            id: 2,
            title: "TikTok",
            img: _8/* default */.Z,
            time: "29 Oct, 05:42 pm",
            size: "2.6 GB"
        },
        {
            id: 3,
            title: "Twitter",
            img: _11/* default */.Z,
            time: "29 Oct, 04:25 pm",
            size: "114.65 MB"
        },
        {
            id: 4,
            title: "Telegram",
            img: _17/* default */.Z,
            time: "29 Oct, 04:22 pm",
            size: "395.63 MB"
        },
        {
            id: 5,
            title: "Pinterest",
            img: _18/* default */.Z,
            time: "29 Oct, 04:14 pm",
            size: "36.95 MB"
        },
        {
            id: 6,
            title: "Gmail",
            img: _19/* default */.Z,
            time: "29 Oct, 03:59 pm",
            size: "71.84 MB"
        },
        {
            id: 7,
            img: _3,
            title: "Instagram",
            time: "29 Oct, 05:39 pm",
            size: "71.84 MB"
        },
        {
            id: 8,
            img: _5,
            title: "Facebook",
            time: "29 Oct, 03:59 pm",
            size: "71.84 MB"
        },
        {
            id: 9,
            img: _6,
            title: "Tinder",
            time: "22 Oct, 03:02 pm",
            size: "1.9 GB"
        },
        {
            id: 10,
            img: _12,
            title: "Viber",
            time: "29 Oct, 12:89 pm",
            size: "362.25 MB"
        },
        {
            id: 11,
            img: _13,
            title: "Kik",
            time: "28 Oct, 03:49 pm",
            size: "364.84 MB"
        },
        {
            id: 12,
            img: _14,
            title: "Skype",
            time: "29 Oct, 02:59 pm",
            size: "279.84 MB"
        },
        {
            id: 13,
            img: _15/* default */.Z,
            title: "Messenger",
            time: "29 Oct, 03:59 pm",
            size: "171.84 MB"
        },
        {
            id: 14,
            img: _16/* default */.Z,
            title: "Chrome Browser",
            time: "29 Oct, 03:50 pm",
            size: "1.1 GB"
        },
        {
            id: 15,
            img: apps_19/* default */.Z,
            title: "Safari",
            time: "28 Oct, 06:20 pm",
            size: "196.3 MB"
        },
        {
            id: 17,
            img: _21/* default */.Z,
            title: "Music",
            time: "27 Oct, 12:10 pm",
            size: "105.63 MB"
        },
        {
            id: 18,
            img: _22/* default */.Z,
            title: "Shadowrocket",
            time: "27 Oct, 11:36 pm",
            size: "241 MB"
        }
    ];
    const [data, setData] = (0,react.useState)(APPLICATIONS);
    const BorderLinearProgress = (0,styled/* default */.ZP)(LinearProgress_LinearProgress)((param)=>{
        let { theme  } = param;
        return {
            height: 4,
            borderRadius: 5,
            ["&.".concat(LinearProgress_linearProgressClasses.colorPrimary)]: {
                backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
            },
            ["& .".concat(LinearProgress_linearProgressClasses.bar)]: {
                borderRadius: 5,
                backgroundColor: theme.palette.mode === "light" ? "#097ae4" : "#308fe8"
            }
        };
    });
    const inputChangeHandler = (e)=>{
        const valueData = e.target.value.trim().toLowerCase();
        const Data = APPLICATIONS.filter((index)=>index.title.toLowerCase().indexOf(valueData) !== -1);
        setData(Data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " bg-[#f5f6fa] pb-6 w-full ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex bg-white h-[60px] sm:h-[70px] pl-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-[98%] sm:w-full mx-auto justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " absolute",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                    icon: "ep:search",
                                                    className: "w-[18px] h-[18px] text-black text-opacity-60 ml-1"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                onChange: inputChangeHandler,
                                                type: "text",
                                                placeholder: "Search Applications",
                                                className: "flex sm:w-4/5 h-[35px] sm:h-[30px] rounded-3xl outline-none pl-8 text-[15px] placeholder-[#667089]"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                class: " sm:w-10/12 w-1/4 md:mr-4 sm:mr-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex text-[0.75rem] text-[#667089] text-bold justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                class: "text-[#667089] font-medium sm:text-[0.5rem]",
                                                children: "DEVICE STORAGE"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[13px] sm:text-[12px]",
                                                children: "15.60 GB used of 127.85 GB"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderLinearProgress, {
                                            variant: "determinate",
                                            value: 12
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-4 bg-white md:w-[95%] rounded-lg mx-auto ",
                    children: data.map((app)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex justify-between text-[0.875rem] text-[#4d5976] h-[70px] items-center border-b-[1px] border-[#e6e8ec] sm:text-[0.7rem] ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex ml-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: app.img,
                                                alt: "img",
                                                className: "flex w-[34px] h-[34px] sm:w-[20px] sm:h-[20px] rounded-xl "
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "pl-6 sm:pl-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "font-bold text-[#4d5976] text-opacity-95",
                                                    children: app.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    class: "text-[13px] mt-1",
                                                    children: [
                                                        "Last Used:",
                                                        app.time
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex md:mr-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        class: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "",
                                                children: app.size
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                                icon: "material-symbols:chevron-right-rounded",
                                                width: 20,
                                                height: 20,
                                                class: "text-[#fff]"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, app.id);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var applications = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1954,9774,2888,179], function() { return __webpack_exec__(250); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);